import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import { RowContent } from 'modules/OHP/applications/components/TransactionInformation';
import * as actions from '../action';
import * as c from '../constant';
import BuildingComponentModal from '../modals/BuildingComponentModal';

function BuildingComponentContent({
  handleEdit,
  handleRemove,
  componentId,
  getSingleComponentType,
  dataInfo,
  ordinanceRevisionId
}) {

  const setModal = useContext(ModalContext);

  useEffect(() => {
    if (_.isEmpty(componentId)) return;
    getSingleComponentType(componentId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(componentId)) return;
    getSingleComponentType(componentId);
  }, [componentId]);

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <BuildingComponentModal type="NEW" ordinanceRevisionId={ordinanceRevisionId} />,
      title: 'Add Building Component',
      modalSize: 'modal-md',
    });
  };

  return (
    <>
      <div className="row mb-3">
        <div className="ml-auto">
          <button
            type="button"
            onClick={handleAddModal}
            className="btn btn-building-component font-weight-bold"
          >
            <i className="fas fa-plus" /> Add Building Component
          </button>
        </div>
      </div>
      <div className="ml-3 card right-section">
        <div className="p-3">
          <div className="d-flex mb-3">
            <div className="col-8 mt-2">
              <span className="font-weight-bold"> Information </span>
            </div>
            <div className="col-4 d-flex">
              <div className="ml-auto">
                <button
                  type="button"
                  className="btn-blank"
                  onClick={handleEdit(dataInfo)}
                >
                  <i className="far fa-edit icon-edit" />
                </button>
                <button
                  type="button"
                  className="btn-blank"
                  onClick={handleRemove(dataInfo)}
                >
                  <i className="far fa-trash-alt icon-delete" />
                </button>
              </div>
            </div>
          </div>
          <hr />
          {!_.isEmpty(dataInfo) ? (
            <React.Fragment>
              <div className="alternate-bg-wrapper p-3 mx-3">
                <RowContent
                  label="Name/Description"
                  value={_.get(dataInfo, 'attributes.name')}
                />
                <RowContent
                  label="Type"
                  value={_.get(dataInfo, 'attributes.type')}
                />
                <RowContent
                  label="Code"
                  value={_.get(dataInfo, 'attributes.code')}
                />
                <RowContent
                  label="Rate 1"
                  value={_.get(dataInfo, 'attributes.rate_1')}
                />
                <RowContent
                  label="Rate 2"
                  value={_.get(dataInfo, 'attributes.rate_2')}
                />
                <RowContent
                  label="Ordinance Revision"
                  value={_.get(dataInfo, 'attributes.ordinance_revision_name')}
                />
                <RowContent
                  label="Is Percent?"
                  value={
                    _.get(dataInfo, 'attributes.is_percent') === 1
                      ? 'Yes'
                      : 'No'
                  }
                />
                <RowContent
                  label="Is Active"
                  value={
                    _.get(dataInfo, 'attributes.is_active') === 1
                      ? 'Yes'
                      : 'No'
                  }
                />
              </div>
            </React.Fragment>
          ) : (
            <div className="d-flex align-items-center justify-content-center h-100">
              <div className="text-center mx-auto py-4">
                <img
                  src={emptyStateImage}
                  className="img-responsive image-wrapper mb-4 mt-3"
                  alt="Empty State"
                />
                <p className="emp-title mb-0"> No Item Found </p>
              </div>
            </div>
          )
          }
        </div>
      </div>
    </>
  );
}

BuildingComponentContent.defaultProps = {
  ordinanceRevisionId: null,
};

BuildingComponentContent.propTypes = {
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  getSingleComponentType: PropTypes.instanceOf(Function).isRequired,
  dataInfo: PropTypes.instanceOf(Object).isRequired,
  componentId: PropTypes.string.isRequired,
  ordinanceRevisionId: PropTypes.number,
};

const mapStateToProps = ({ api }, { match }) => ({
  dataInfo:
    _.get(api, `${c.GET_SINGLE_BUILDING_COMPONENT_TYPE}.item`) || {},
  componentId: _.get(match, 'params.componentId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BuildingComponentContent);
